import { ContainersLoader } from './ContainersLoader';

export const containersLoader: { (token?: string): ContainersLoader } = (token) =>
  new ContainersLoader(token);
